<template>
    <div class="text-secondary align-self-stretch flex-fill d-flex align-items-center justify-content-center">
        <h6>{{ message }}</h6>
    </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        default: 'There is no content to display',
      },
    },
  }
</script>
